import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper";
import { BsArrowLeft } from "react-icons/bs";

import "swiper/css";
import "swiper/css/pagination";

import { useEffect, useState } from "react";

function HotelGallery({ photos = [] }) {
  const [isOpen, setIsOpen] = useState(false);
  const [current, setCurrent] = useState(0);

  // ESC
  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "Escape") setIsOpen(false);
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, []);

  if (!photos.length) return null;

  return (
    <>
      {/* ================= MOBILE ================= */}
      <div className="md:hidden w-full relative overflow-hidden">

        <div className="pointer-events-none absolute top-0 left-0 w-full h-28 bg-gradient-to-b from-black/60 to-transparent"></div>

        <Swiper
          modules={[Pagination, Autoplay]}
          slidesPerView={1}
          pagination={{ clickable: true }}
          autoplay={{ delay: 3500 }}
          loop
          className="w-full"
        >
          {photos.map((img, i) => (
            <SwiperSlide key={i}>
              <div
                onClick={(e) => {
                  if (e.target.closest(".back-btn")) return;
                  setCurrent(i);
                  setIsOpen(true);
                }}
                className="cursor-pointer relative"
              >
                <div
                  onClick={() => window.history.back()}
                  className="absolute top-4 left-4 z-10 bg-white/90 backdrop-blur-md rounded-full p-2 shadow-md"
                >
                  <BsArrowLeft className="text-black text-lg" />
                </div>
                <img
                 src={img}
                 className="w-full aspect-[3/4] object-cover" />

                {/* 🔥 COUNTER */}
                <div className="absolute top-3 right-3 bg-black/50 text-white text-xs px-2 py-1 rounded-md">
                  {i + 1} / {photos.length}
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        {/* FADE */}
        <div className="pointer-events-none absolute bottom-0 left-0 w-full h-24 bg-gradient-to-t from-white via-white/60 to-transparent"></div>

        {/* SHADOW PLUS FORTE */}
        <div className="pointer-events-none absolute bottom-0 left-0 w-full h-12 bg-gradient-to-b from-black/30 via-black/15 to-transparent"></div>
      </div>

      {/* ================= DESKTOP ================= */}
      <div className="hidden md:grid grid-cols-4 grid-rows-2 gap-2 rounded-2xl overflow-hidden h-[380px] lg:h-[420px]">

        {/* MAIN */}
        <div
          className="col-span-2 row-span-2 cursor-pointer overflow-hidden"
          onClick={() => {
            setCurrent(0);
            setIsOpen(true);
          }}
        >
          <img
            src={photos[0]}
            className="w-full h-full object-cover block transition duration-300 hover:brightness-95"
          />
        </div>

        {/* SMALL */}
        {photos.slice(1, 5).map((img, i) => (
          <div
            key={i}
            className="relative cursor-pointer h-full overflow-hidden"
            onClick={() => {
              setCurrent(i + 1);
              setIsOpen(true);
            }}
          >
            <img
              src={img}
              className="w-full h-full object-cover block transition duration-300 hover:brightness-95"
            />

            {i === 3 && (
              <div className="absolute inset-0 bg-black/40 flex items-center justify-center text-white font-medium text-sm">
                +{photos.length} photos
              </div>
            )}
          </div>
        ))}
      </div>

      {/* ================= MODAL ================= */}
      {isOpen && (
  <div className="fixed inset-0 bg-black/95 z-[9999] flex flex-col">

    {/* HEADER */}
    <div className="flex justify-between items-center p-4 text-white text-sm">
      <span>{current + 1} / {photos.length}</span>
      <button onClick={() => setIsOpen(false)}>✕</button>
    </div>

    {/* IMAGE */}
    <div className="flex-1 flex items-center justify-center">
      <img
        src={photos[current]}
        className="max-h-full max-w-full object-contain"
        draggable={false}
      />
    </div>

    {/* NAV */}
    <div className="flex justify-between p-4 text-white text-2xl">
      <button
        onClick={() =>
          setCurrent((prev) =>
            prev === 0 ? photos.length - 1 : prev - 1
          )
        }
        className="bg-white/10 rounded-full px-3 py-1"
      >
        ←
      </button>

      <button
        onClick={() =>
          setCurrent((prev) =>
            prev === photos.length - 1 ? 0 : prev + 1
          )
        }
        className="bg-white/10 rounded-full px-3 py-1"
      >
        →
      </button>
    </div>

  </div>
)}
    </>
  );
}

export default HotelGallery;